import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../../queries';
import { useAPIErrorHandler } from '../../useAPIErrorHandler';
import type { Nullable } from '../../../../types/common/utility';

export function useAccountDetails(
  id: Nullable<string>,
  options?: Record<string, unknown>
) {
  const handleAPIError = useAPIErrorHandler();

  return useQuery({
    ...queries.accounts.detail(id as string),
    keepPreviousData: true,
    onError: handleAPIError("Unable to fetch account's details"),
    enabled: Boolean(id),
    ...options,
  });
}
